import React, { Component, useState, useEffect } from 'react';

import { ButtonGroup, Button, InputGroup, FormControl } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class ResourceButton extends Component {
  state = {
    label: "",
    status: "idle",
    disabled: true,
    opacity: 1,
    muted: false
  };

  constructor(props) {
    super(props);

    this.blinkTask = null;

    // this.onKeyDown = this.onKeyDown.bind(this);
    // this.onKeyUp = this.onKeyUp.bind(this);
  }

  setStatus = (status) => {
    this.setState(state => ({
      status: status,
    }));
    let style = this.style[status];
    style.blink ? this.startBlink() : this.stopBlink();
  }

  setLabel = (label) => {
    let disabled = (label === "");
    this.setState(state => ({
      label: label,
      disabled: disabled
    }));
  }

  enable = () => {
    this.setState(state => ({
      disabled: true
    }));
  }

  disable = () => {
    this.setState(state => ({
      disabled: true
    }));
  }

  mute = () => {
    this.setState(state => ({
      muted: true
    }));
  }

  unmute = () => {
    this.setState(state => ({
      muted: false
    }));
  }

  activateMedia = () => {
    try {
      let index = this.props.buttonItem.id;
      this.props.ws.request("media_switch",
                            {"resource": {"type": this.resource_type, "index": index}})
    } catch (error) {
      console.error("Failed to request media switch");
    }
  };

  deactivateMedia = () => {
    try {
      let index = this.props.buttonItem.id;
      this.props.ws.request("media_deactivate",
                            {"resource": {"type": this.resource_type, "index": index}})
    } catch (error) {
      console.error("Failed to request media switch");
    }
  };

  startBlink = () => {
    if (this.blinkTask !== null) return;
    this.blinkTask = setInterval(() => {
      this.setState(state => ({
        opacity: (state.opacity === 1) ? 0.8 : 1
      }));
    }, 700);
  }

  stopBlink = () => {
    if (this.blinkTask !== null) clearInterval(this.blinkTask);
    this.blinkTask = null;
    this.setState(state => ({
      opacity: 1
    }));
  }

  requestDial = () => {
    try {
      let index = this.props.buttonItem.id;
      this.props.ws.request("dial",
                            {"resource": {"type": this.resource_type, "index": index}})
    } catch (error) {
      console.error("Failed to request dial");
    }
  }

  requestAnswer = () => {
    try {
      let index = this.props.buttonItem.id;
      this.props.ws.request("answer",
                            {"resource": {"type": this.resource_type, "index": index}})
    } catch (error) {
      console.error("Failed to request answer");
    }
  }

  requestHangup = () => {
    try {
      let index = this.props.buttonItem.id;
      this.props.ws.request("hangup",
                            {"resource": {"type": this.resource_type, "index": index}})
    } catch (error) {
      console.error("Failed to request hangup");
    }
  }

  requestTransmit = (action) => {
    try {
      let index = this.props.buttonItem.id;
      this.props.ws.request("transmit",
                            {"action": action,
                             "resource": {"type": this.resource_type, "index": index}})
    } catch (error) {
      console.error("Failed to request transmit " + action);
    }
  }

  requestTransmitStart = () => {
    if (this.state.status === "transmitting") {
      return;
    }
    this.requestTransmit("start");
  }

  requestTransmitStop = () => {
    this.requestTransmit("stop");
  }

  requestHold = (action) => {
    try {
      let index = this.props.buttonItem.id;
      this.props.ws.request("hold",
                            {"resource": {"type": this.resource_type, "index": index},
                             "action": action})
    } catch (error) {
      console.error("Failed to request hold " + action);
    }
  };

  requestHoldStart = () => {
    this.requestHold("start");
  }

  requestHoldStop = () => {
    this.requestHold("stop");
  }

  requestFocus = (action) => {
    try {
      let index = this.props.buttonItem.id;
      this.props.ws.request("focus",
                            {"action": action,
                             "resource": {"type": this.resource_type, "index": index}})
    } catch (error) {
      console.error("Failed to request focus " + action);
    }
  }

  requestFocusStart = () => {
    if (this.state.status === "focus") {
      return;
    }
    this.requestFocus("start");
    this.setStatus("focus");
  }

  requestFocusStop = () => {
    this.requestFocus("stop");
  }

  // onKeyDown = (event) => {
  //   // Ignore repeated events
  //   if (event.repeat) return;

  //   if (event.keyCode === this.props.buttonItem.keyCode) {
  //     this.onKeyStarted = Date.now();
  //     this.handleClick();
  //   }
  // }

  // onKeyUp = (event) => {
  //   // Ignore repeated events
  //   if (event.repeat) return;

  //   if (event.keyCode === this.props.buttonItem.keyCode) {
  //     if ((Date.now() - this.onKeyStarted) > 300) {
  //       this.handleClick();
  //     }
  //   }
  // }


}


export class Monitor extends ResourceButton {

  resource_type = "monitor";

  style = {
    idle: {className: "btn-secondary",
           blink: false,
           action1: {icon: "phone-alt", disabled: false},
           action2: {icon: "thumbtack", disabled: true}},
    active: {className: "btn-success",
             blink: false,
             action1: {icon: "times-circle", disabled: false},
             action2: {icon: "thumbtack", disabled: false}},
    ringing: {className: "btn-warning",
              blink: true,
              action1: {icon: "phone-alt", disabled: false},
              action2: {icon: "times-circle", disabled: false}},
    calling: {className: "btn-warning",
              blink: true,
              action1: {icon: "times-circle", disabled: false},
              action2: {icon: "thumbtack", disabled: true}},
    busy: {className: "btn-danger",
           blink: false,
           action1: {icon: "times-circle", disabled: false},
           action2: {icon: "thumbtack", disabled: false}},
    talking: {className: "btn-talking",
              blink: false,
              action1: {icon: "times-circle", disabled: false},
              action2: {icon: "thumbtack", disabled: false}},
    transmitting: {className: "btn-info",
                   blink: false,
                   action1: {icon: "times-circle", disabled: false},
                   action2: {icon: "thumbtack", disabled: false}},
    focus: {className: "btn-info",
            blink: false,
            action1: {icon: "times-circle", disabled: false},
            action2: {icon: "thumbtack", disabled: false, active: true}},
  };

  activateMediaTransmission = () => {
    try {
      let index = this.props.buttonItem.id;
      this.props.ws.request("media_switch",
                            {"resource": {"type": "transmission", "index": index}})
    } catch (error) {
      console.error("Failed to request media switch");
    }
  };

  action1 = (event) => {
    event.preventDefault();
    if (this.state.status === "idle") {
      this.requestDial();
      this.activateMedia();
    } else if (this.state.status === "ringing") {
      this.requestAnswer();
      this.activateMedia();
    } else if (["active", "busy", "calling", "talking",
                "transmitting", "focus"].includes(this.state.status)) {
      this.requestHangup();
    }
  }

  action2 = (event) => {
    event.preventDefault();
    if (this.state.status === "idle") {
      return;
    } else if (this.state.muted) {
      this.activateMedia();
    } else if (["active", "busy", "talking", "transmitting"].includes(this.state.status)) {
      this.requestFocusStart();
      this.activateMediaTransmission();
    } else if (this.state.status === "focus") {
      this.requestFocusStop();
      this.activateMedia();
    } else if (this.state.status === "ringing") {
      this.requestHangup();
    }
  }

  labelMouseDown = (event) => {
    event.preventDefault();
    if (["idle", "focus", "ringing", "calling"].includes(this.state.status)) {
      return;
    }
    this.requestTransmitStart();
    this.activateMediaTransmission();
  }

  labelMouseUp = (event) => {
    event.preventDefault();
    if (["idle", "focus", "ringing", "calling"].includes(this.state.status)) {
      return;
    }
    this.requestTransmitStop();
    this.activateMedia();
  }

  componentDidMount = () => {
    // document.addEventListener('keydown', this.onKeyDown);
    // document.addEventListener('keyup', this.onKeyUp);
  }

  componentWillUnmount = () => {
    // document.removeEventListener('keydown', this.onKeyDown);
    // document.removeEventListener('keyup', this.onKeyUp);
  }
      // <div className="console-button"
      //      id={buttonItem.id}
      //      onMouseDown={this.onMouseDown}
      //      onMouseUp={this.onMouseUp}
      //      onTouchStart={this.onMouseDown}
      //      onTouchEnd={this.onMouseUp}>
      //   <div className="key-bind">{String.fromCharCode(buttonItem.keyCode)}</div>
      //   <div className="label">{this.state.label}</div>
      // </div>

  render = () => {
    let style = this.style[this.state.status];
    return (this.state.disabled) ? (
      <div className="btn-monitor btn-placeholder d-none d-sm-block mb-2 mt-2"></div>
    ) : (
      <ButtonGroup className={"btn-group btn-monitor " + style.className + " mb-2 mt-2"}
                   style={{opacity: this.state.opacity}}>
        <Button variant="none"
                size="lg"
                active={style.action1.active === true}
                disabled={style.action1.disabled || this.state.disabled}
                onClick={this.action1}>
          <FontAwesomeIcon icon={style.action1.icon} />
        </Button>
        <Button variant="none"
                size="lg"
                active={style.action2.active === true}
                disabled={style.action2.disabled || this.state.disabled}
                onClick={this.action2}>
          <FontAwesomeIcon icon={this.state.muted ? "volume-mute" : style.action2.icon} />
        </Button>
        <Button variant="none"
                size="lg"
                className="btn-group-label"
                disabled={this.state.disabled}
                onMouseDown={this.labelMouseDown}
                onMouseUp={this.labelMouseUp}
                onTouchStart={this.labelMouseDown}
                onTouchEnd={this.labelMouseUp}
                onTouchCancel={this.labelMouseUp}
                >
          <span className="p-1 rounded"
              onMouseDown={this.labelMouseDown}
              onMouseUp={this.labelMouseUp}>
            {this.state.label}
          </span>
        </Button>
      </ButtonGroup>
    )
  }
}

export class Device extends ResourceButton {

  resource_type = "device";

  style = {
    idle: {className: "btn-placeholder",
           blink: false,
           action1: {icon: null, disabled: true},
           action2: {icon: null, disabled: true}},
    ringing: {className: "btn-warning",
              blink: true,
              action1: {icon: "phone-alt", disabled: false},
              action2: {icon: "volume-up", disabled: true}},
    calling: {className: "btn-warning",
              blink: true,
              action1: {icon: "times-circle", disabled: false},
              action2: {icon: "volume-up", disabled: true}},
    busy: {className: "btn-danger",
           blink: false,
           action1: {icon: "times-circle", disabled: false},
           action2: {icon: "volume-up", disabled: false}},
  };

  setStatus = (status) => {
    (this.state.status !== status && status === "idle") && this.deactivateMedia();
    (this.state.status === "idle" && status === "calling") && this.activateMedia();
    this.setState(state => ({
      status: status,
    }));
    let style = this.style[status];
    style.blink ? this.startBlink() : this.stopBlink();
  }

  activateMedia = () => {
    try {
      this.requestTransmitStopAll();
      let index = this.props.buttonItem.id;
      this.props.ws.request("media_switch",
                            {"resource": {"type": this.resource_type, "index": index}})
    } catch (error) {
      console.error("Failed to request media switch");
    }
  };

  mute = () => {
    this.setState(state => ({
      muted: true
    }));
    this.requestHoldStart();
  }

  unmute = () => {
    this.setState(state => ({
      muted: false
    }));
    this.requestHoldStop();
  }

  requestTransmitStopAll = () => {
    try {
      this.props.ws.request("transmit", {"action": "stop"})
    } catch (error) {
      console.error("Failed to request transmit stop for all:" + error);
    }
  };

  requestTransfer = () => {
    try {
      let index = this.props.buttonItem.id;
      this.props.ws.request("transfer",
                            {"resource": {"type": this.resource_type, "index": index}})
    } catch (error) {
      console.error("Failed to request transfer");
    }
  }

  action1 = (event) => {
    event.preventDefault();
    if (this.state.status === "busy") {
      this.requestHangup();
    } else if (this.state.status === "ringing") {
      this.requestAnswer();
      this.activateMedia();
    } else if (this.state.status === "calling") {
      this.requestHangup();
    }
  }

  action2 = (event) => {
    event.preventDefault();
    if (this.state.status === "busy") {
      (this.state.muted) && this.activateMedia();
      (!this.state.muted) && this.deactivateMedia();
    }
  }

  action3 = (event) => {
    event.preventDefault();
    if (this.state.status === "busy") {
      this.requestTransfer();
    }
  }

  render = () => {
    let style = this.style[this.state.status];
    let action2Active = false;
    if (["busy", "ringing", "calling"].includes(this.state.status)) {
      action2Active = !this.state.muted;
    }
    return (this.state.disabled || this.state.status === "idle") ? (
      null
      // Device placeholder
      // <div className="btn-device btn-placeholder mb-2 mt-2"></div>
    ) : (
      <ButtonGroup className={"btn-group btn-device " + style.className + " mb-2 mt-2"}
                   style={{opacity: this.state.opacity}}>
        <Button variant="none"
                size="lg"
                disabled={style.action1.disabled || this.state.disabled}
                onClick={this.action1}>
          <FontAwesomeIcon icon={style.action1.icon} />
        </Button>
        <Button variant="none"
                size="lg"
                disabled={style.action2.disabled || this.state.disabled}
                onClick={this.action2}
                active={action2Active}>
          <FontAwesomeIcon icon={this.state.muted ? "volume-mute" : style.action2.icon} />
        </Button>
        <Button variant="none"
                size="lg"
                disabled={this.state.status !== "busy" || this.props.transferDisabled}
                onClick={this.action3}>
          <FontAwesomeIcon icon="eye" />
        </Button>
        <Button variant="none"
                size="lg"
                className="btn-group-label"
                disabled={this.state.disabled}>
          <span className="p-1 rounded"
              onMouseDown={this.labelMouseDown}
              onMouseUp={this.labelMouseUp}>
            {this.state.label}
          </span>
        </Button>
      </ButtonGroup>
    )
  }
}

export function PTT(props) {

  const [fixed, setFixed] = useState(false);
  const [pressed, setPressed] = useState(false);

  const ws = props.ws;

  const onButtonMouseDown = (event) => {
    if (props.disabled) return;
    requestTransmit("start");
  }

  const onButtonMouseUp = (event) => {
    if (props.disabled) return;
    requestTransmit("stop");
    setFixed(false);
    setPressed(false);
  }

  const onKeyDown = (event) => {
    if (props.disabled) return;
    // Ignore repeated events
    if (event.repeat) return;
    if (event.keyCode === 32) { // Space
      event.preventDefault();
      requestTransmit("start");
      setPressed(true);
    }
  }

  const onKeyUp = (event) => {
    if (props.disabled) return;
    // Ignore repeated events
    if (event.repeat) return;
    if (event.keyCode === 32) { // Space
      event.preventDefault();
      requestTransmit("stop");
      setFixed(false);
      setPressed(false);
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('keyup', onKeyUp);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('keyup', onKeyUp);
    };
  }, [onKeyUp, onKeyDown]);

  const activateMediaTransmission = () => {
    try {
      ws.request("media_switch",
                 {"resource": {"type": "transmission", "index": 1}})
    } catch (error) {
      console.error("Failed to request media switch");
    }
  };

  const activateMediaMonitor = () => {
    try {
      ws.request("media_switch",
                 {"resource": {"type": "monitor", "index": 1}})
    } catch (error) {
      console.error("Failed to request media switch");
    }
  };

  const requestTransmit = (action) => {
    try {
      ws.request("transmit", {"action": action})
      if (action === "start") activateMediaTransmission();
      else if (action === "stop") activateMediaMonitor();
    } catch (error) {
      console.error("Failed to request transmit " + action + ":" + error);
    }
  };

  const toggleTransmit = () => {
    if (props.disabled) return;
    if (fixed) requestTransmit("stop");
    else requestTransmit("start");
    setFixed(!fixed);
    setPressed(!fixed);
  };

  return (
    <ButtonGroup className="btn-group-ptt">
      <Button variant="none"
              size="lg"
              active={fixed}
              className="btn-ptt-fix btn-secondary mb-2 mt-2"
              onClick={toggleTransmit}
              disabled={props.disabled}>
      <FontAwesomeIcon icon="thumbtack" />
      </Button>
      <Button variant="none"
              size="lg"
              active={pressed}
              className="btn-ptt btn-secondary mb-2 mt-2"
              onMouseDown={onButtonMouseDown}
              onMouseUp={onButtonMouseUp}
              onTouchStart={onButtonMouseDown}
              onTouchEnd={onButtonMouseUp}
              onTouchCancel={onButtonMouseUp}
              disabled={props.disabled}>
        <FontAwesomeIcon icon="microphone" />
      </Button>
    </ButtonGroup>
  )
}


export function DialPad(props) {
  // TODO color when button is clicked
  // TODO maybe change icon style when filled(enable/disable)
  const ws = props.ws;
  const [contact, setContact] = useState("");

  const handleInput = e => {
    e.preventDefault();
    setContact(e.target.value);
  };

  const requestDial = () => {
    if (contact === "") return;
    try {
      ws.request("dial", {"endpoint": {"number": contact}})
      setContact("");
      return true;
    } catch (error) {
      console.error("Failed to dial " + contact);
    }
    return false;
  };

  const onKeyDown = (event) => {
    // Ignore repeated events
    if (event.repeat) return;
    if (event.keyCode === 13) { // CR
      requestDial();
    }
  }


  return (
  <InputGroup className="input-group-dial mb-3">
    <FormControl
      type="tel"
      name="dialpad"
      placeholder=""
      className="rounded"
      onChange={handleInput}
      onKeyDown={onKeyDown}
      value={contact}
      autocomplete="off"
      disabled={props.disabled}
    />
    <InputGroup.Append className="rounded ml-3">
      <Button variant="primary" disabled={props.disabled || (contact.trim() === '')} size="lg" className="rounded" onClick={requestDial}>
        <FontAwesomeIcon icon="phone-alt" />
      </Button>
    </InputGroup.Append>
  </InputGroup>
  )
}
